// eslint-disable-next-line @typescript-eslint/no-var-requires
export default require(`./${process.env.VUE_APP_INSTANCE}.ts`).default;
